import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Colors } from 'react-native-paper';

import { DateTime } from 'luxon';
import { pixelDimensions } from '../../config/utils';
import { AppButton, AppText } from '../form';
import { appColors } from '../../assets/styles/global';

const CardClassTrainer = (_class) => {
  const { data } = _class;
  return (
    <View style={styles.baseView}>
      <Card style={styles.card}>
        <View style={styles.contentCard}>
          <View style={[styles.viewInfo, { justifyContent: 'space-between', marginVertical: pixelDimensions(2) }]}>
            <AppText style={styles.text}>
              Data:
              {' '}
              {data?.isWorker
                ? DateTime.fromFormat(data?.date.substring(0, 10), 'yyyy-LL-dd').toFormat('dd/LL')
                : data?.date}
            </AppText>
            <AppText style={styles.text}>
              Horário:
              {' '}
              {`${data?.horario}  ${data.isWorker ? (data?.fim) : ''}`}

            </AppText>

          </View>
          <View style={styles.viewInfo}>
            <AppText style={styles.text}>
              {data.isWoker ? 'Empresa' : 'Nome'}
              {' '}
              {`${data?.name}`}

            </AppText>
          </View>

        </View>
        <AppButton label={data?.textButton} labelStyle={styles.textButton} style={styles.cardButton} disabled={data.disabled || data.textButton === 'Finalizada'} onPress={data?.handleButton} />
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: pixelDimensions(3),
    margin: pixelDimensions(2),
  },
  contentCard: {
    alignItems: 'left',
  },
  cardButton: {
    marginTop: pixelDimensions(3),
    paddingVertical: pixelDimensions(1.5),
    paddingHorizontal: pixelDimensions(5),
    borderRadius: 8,
    alignItems: 'center',
  },
  viewAvatar: {
    paddingHorizontal: pixelDimensions(3),
  },
  viewInfo: {
    flexDirection: 'row',

    paddingHorizontal: pixelDimensions(3),
  },
  buttonSelect: {
    alignSelf: 'flex-end',
    padding: pixelDimensions(2),
    marginBottom: pixelDimensions(1.5),
  },
  textSubTitle: {
    fontSize: pixelDimensions(4),
    maxWidth: pixelDimensions(65),
    marginBottom: pixelDimensions(3),
  },
  textButton: {
    color: Colors.white,
    fontFamily: 'MBold',
  },
  textTitle: {
    alignSelf: 'center',
    fontFamily: 'MBold',
    fontSize: pixelDimensions(4.5),
    marginTop: pixelDimensions(3),
  },
  imageChangePic: {
    backgroundColor: 'white',
    width: pixelDimensions(15),
    height: pixelDimensions(15),
    resizeMode: 'contain',

  },
  viewAcceptAgreement: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: pixelDimensions(3),
  },
  buttonAgreement: {
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(4),
  },
  textAgreement: {
    color: Colors.white,
    fontSize: pixelDimensions(3.5),
  },
});

export default CardClassTrainer;
